import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-purchasedsuccess',
  templateUrl: './exam-purchasedsuccess.component.html',
  styleUrls: ['./exam-purchasedsuccess.component.css']
})
export class ExamPurchasedsuccessComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
